import script from "./NewReview.vue?vue&type=script&setup=true&lang=js"
export * from "./NewReview.vue?vue&type=script&setup=true&lang=js"

import "./NewReview.vue?vue&type=style&index=0&id=1c325e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c325e20"]])

export default __exports__